var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$can('read', 'mentor'))?_c('mentor-mentorships'):_vm._e(),(_vm.$can('read', 'mentee'))?_c('mentee-mentorships'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }